import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import { toggleResetPassModal } from '../actions/Profile';
import {
  postReleaseNote,
  getReleaseNotes,
  getMaintenanceNotes,
  updateReleaseNotes,
  deleteReleaseNotes,
} from '../actions/EpikBoxes';
import UpdateUserPasswordModal from './UpdateUserPasswordModal';
import CustomModal from './CustomModal';
import './UserProfile.css';
import ReleaseNote from './ReleaseNote';
import ReleaseDisplayNotes from './ReleaseDisplayNotes';
import ActiveMaintenance from './ActiveMaintenance';
import { addSystemLogs } from '../actions/SystemLogs';
import TwoFactorSetup from './TwoFactorSetup';
import utils from '../lib/utils';

const UserProfile = ({
  profile,
  openModal,
  toggleResetPassModal,
  resetPassword,
  user,
  postReleaseNote,
  getReleaseNotes,
  getMaintenanceNotes,
  toggleIframe,
  updateReleaseNotes,
  deleteReleaseNotes,
  addSystemLogs,
}) => {
  const { name, email, phoneNumber, registerDate, company } = profile;
  const [openReleaseModal, setOpenReleaseModal] = useState(false);
  const [openReleaseDisplayModal, setOpenReleaseDisplayModal] = useState(false);
  const [releaseDisplayArr, setReleaseDisplayArr] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [isActiveMaintenanceModalOpen, setisActiveMaintenanceModalOpen] = useState(false);
  const [activeMaintenanceNotes, setactiveMaintenanceNotes] = useState([]);
  const [editReleaseHtml, setEditReleaseHtml] = useState('');

  const [twoFactorModal, setTwoFactorModal] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const history = useHistory();
  const ProfileItem = ({ title, data }) => (
    <div className="profile-info-item">
      <h5 className="profile-info-title">{title}</h5>
      <hr className="profile-info-line" />
      <span className="profile-info-data">{data || `${title} is not specified`}</span>
    </div>
  );
  useMemo(async () => {
    if (resetPassword) {
      toggleResetPassModal(true);
    }
  }, []);
  const onReleaseDisplay = async () => {
    const displayReleaseArray = await getReleaseNotes(token);
    setReleaseDisplayArr(displayReleaseArray);
    setOpenReleaseDisplayModal(true);
  };

  const onDeleteReleaseNote = async (noteID) => {
    try {
      // Call  deleteReleaseNotes action or API function
      await deleteReleaseNotes(token, noteID);
      // If deletion is successful, update the releaseDisplayArr
      const updatedReleaseArray = await getReleaseNotes(token);
      setReleaseDisplayArr(updatedReleaseArray);
    } catch (error) {
      console.error('Error deleting release note:', error);
      // Handle error if deletion fails
    }
  };
  const onActiveMaintenanceDisplay = async () => {
    const maintenanceNotes = await getMaintenanceNotes(token);
    setactiveMaintenanceNotes(maintenanceNotes);
    setisActiveMaintenanceModalOpen(true);
  };

  const onformValues = values => {
    setFormValues(values);
  };

  const flattenObject = obj => {
    const flattened = {};

    Object.keys(obj).forEach(key => {
      const value = obj[key];

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (Object.keys(value).length === 0) flattened[key] = value;
        Object.assign(flattened, flattenObject(value));
      } else {
        flattened[key] = value;
      }
    });

    return flattened;
  };

  const onTwoFactorSetup = () => {
    setTwoFactorModal(!twoFactorModal)
  }

  const onReleasePublish = async () => {
    if (formValues.frequency === 'One Time' && formValues.type === 'Maintenance Notification')
      delete formValues.recFrequency;

    const isNotEmpty = Object.values(flattenObject(formValues)).every(x => x.length > 0);

    if (isNotEmpty) {
      if (formValues.type === 'Release Notes') {
        const titleHtml = `<p><strong>${formValues.title}</strong></p>\n`;
        const htmlText = titleHtml + formValues.htmlText;
        formValues.htmlText = htmlText;
      }
      const res = await postReleaseNote(token, formValues);
      if (res) {
        setOpenReleaseModal(false);
        setEditReleaseHtml('');
        const body = {
          actionType: 'system',
          description: `${formValues.type} has been added`,
        };
        await addSystemLogs(token, body);
      }
    } else {
      toast.error('Please fill all the fields.');
    }
  };

  const onUpdatePublish = async () => {
    delete formValues.frequency;
    const newFormData = {
      frequency: 'One Time',
      htmlText: formValues.htmlText,
      type: formValues.type,
      title: formValues.title,
      publishDate: formValues.publishDate,
      publishTime: formValues.publishTime,
      _id: formValues._id,
    };
    const isNotEmpty = Object.values(flattenObject(newFormData)).every(x => x.length > 0);

    if (isNotEmpty) {
      if (newFormData.type === 'Release Notes') {
        const titleHtml = `<p><strong>${newFormData.title}</strong></p>\n`;
        const htmlText = titleHtml + newFormData.htmlText;
        newFormData.htmlText = htmlText;
      }
      const res = await updateReleaseNotes(token, newFormData);
      if (res) {
        setOpenReleaseModal(false);
        setEditReleaseHtml('');
        const body = {
          actionType: 'system',
          description: `${newFormData.type} has been added`,
        };
        await addSystemLogs(token, body);
      }
    } else {
      toast.error('Please fill all the fields.');
    }
  };

  const closeMaintenanceModal = value => {
    setisActiveMaintenanceModalOpen(value);
  };

  const onMonitoringDashboard = () => {
    history.push('/dashboard-monitor');
  };

  const latestEdit = data => {
    const newHtml = {
      htmlText: data,
    };
    setEditReleaseHtml(newHtml);
  };

  useEffect(() => {
    if (editReleaseHtml) {
      setOpenReleaseModal(true);
    }
  }, [editReleaseHtml]);
  return (
    <>
      <Row>
        <Col md={12}>
          <div className="profile-info-container text-left">
            <ProfileItem title="Name" data={name} />
            <ProfileItem title="Email" data={email} />
            <ProfileItem
              title="Company"
              data={company ? `${company.name} (Type: ${company.companyType})` : ''}
            />
            <ProfileItem title="Phone Number" data={phoneNumber} />
            <ProfileItem title="Created On" data={utils.getDateTimeFormat(registerDate, 'regular')} />
            <ProfileItem title="User TimeZone"  data={Intl.DateTimeFormat().resolvedOptions().timeZone}/>
            <Row>
              <Col md={3} className="d-flex flex-column align-items-start">
                <Button color="link" onClick={onReleaseDisplay}>
                  Release Notes
                </Button>
                {(!['user', 'admin', 'enterpriseAdmin'].includes(user.role)) && <Link to="/system-log">
                  <Button color="link">System Log</Button>
                </Link>}
                {user?.dataCenterMonitor && (
                  <Link to="/infrastructure">
                    <Button color="link">Data Center Monitor</Button>
                  </Link>
                )}
              </Col>
              {user.role === 'superAdmin' && (
                <Col md={3} className="d-flex flex-column align-items-start">
                  <Button color="link" onClick={onActiveMaintenanceDisplay}>
                    Active Maintenance Notifications
                  </Button>
                  <Button color="link" onClick={() => setOpenReleaseModal(true)}>
                    Post a Release Note
                  </Button>
                </Col>
              )}
              {(!['user', 'admin', 'enterpriseAdmin'].includes(user.role)) &&
                <Col md={3} className="d-flex flex-column align-items-start">
                  {/* {user?.deviceMonitor && (
                  <Button color="link" onClick={onMonitoringDashboard}>
                    Device Monitor
                  </Button>
                )} */}
                  <Button color="link" onClick={() => toggleIframe(true)}>
                    Document
                  </Button>
                </Col>}
              <Col md={3} className="d-flex flex-column align-items-start">
                {user.twoFactor && <Button color="link" onClick={() => setTwoFactorModal(true)}>
                  Setup-2-Factor-Authentication
                </Button>}
                <Button color="link" onClick={() => toggleResetPassModal(true)}>
                  Reset password
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {openModal && (
        <UpdateUserPasswordModal
          resetPassword={resetPassword}
          isOpen={openModal}
          onCancel={() => toggleResetPassModal(false)}
        />
      )}
      <CustomModal
        header="Release Note"
        confirmBtnText={editReleaseHtml ? 'Update' : 'Submit'}
        isOpen={openReleaseModal}
        onCancel={() => {
          setOpenReleaseModal(false);
          setEditReleaseHtml('');
        }}
        onConfirm={editReleaseHtml ? onUpdatePublish : onReleasePublish}
        wider
      >
        <ReleaseNote
          currentState={editReleaseHtml?.htmlText}
          edit
          releaseFormValues={onformValues}
        />
      </CustomModal>
      <CustomModal
        header="Release Note"
        isOpen={openReleaseDisplayModal}
        onCancel={() => setOpenReleaseDisplayModal(false)}
        submitDisplay
      >
        <ReleaseDisplayNotes releaseDisplayArr={releaseDisplayArr} latestEdit={latestEdit}  onDeleteReleaseNote={onDeleteReleaseNote} // Pass the callback function
 />
      </CustomModal>
      <CustomModal
        header="Active Maintenance Notifications"
        isOpen={isActiveMaintenanceModalOpen}
        onCancel={() => setisActiveMaintenanceModalOpen(false)}
        submitDisplay
        close
        medium
      >
        <ActiveMaintenance
          notes={activeMaintenanceNotes}
          updateReleaseNotes={updateReleaseNotes}
          closeMaintenanceModal={closeMaintenanceModal}
          deleteReleaseNotes={deleteReleaseNotes}
        />
      </CustomModal>
      {twoFactorModal && <TwoFactorSetup isOpen={twoFactorModal} toggleModal={onTwoFactorSetup} />}
    </>
  );
};

const mapStateToProps = state => ({
  openModal: state.UIState.profile.openResetPassModal,
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  toggleResetPassModal: isOpen => dispatch(toggleResetPassModal(isOpen)),
  postReleaseNote: (token, note) => dispatch(postReleaseNote(token, note)),
  updateReleaseNotes: (token, note) => dispatch(updateReleaseNotes(token, note)),
  getReleaseNotes: token => dispatch(getReleaseNotes(token)),
  getMaintenanceNotes: token => dispatch(getMaintenanceNotes(token)),
  deleteReleaseNotes: (token, noteID) => dispatch(deleteReleaseNotes(token, noteID)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserProfile);
